module.exports = "/assets/data/aa7515ba30d44c08185433f992794d72-WF6.data.json";